window.T4SThemeSP = window.T4SThemeSP || {};

T4SThemeSP.AccordionTrigger = (function () {
  function handleSlotChange() {
    // Listen for the custom event instead of slot change
    // document.addEventListener('accordion-slot-changed', (e) => {
    //   console.log('Accordion slot changed event received:', e.detail);

    //   if (e.detail.type === 'heading') {
    //     const hasReviewStars = e.detail.nodes.some(node => 
    //       node.querySelector?.('.custom-review-stars')
    //     );

    //     console.log('Heading content changed:', {
    //       type: e.detail.accordionType,
    //       hasReviewStars
    //     });

    //     // If this is a review accordion and it has review stars
    //     if (e.detail.accordionType === 'review' && hasReviewStars) {
    //       console.log('Review accordion detected with stars');
    //     }
    //   }
    // });


    // write a timer to wait if the document.querySelector('.custom-review-stars') have child nodes
    // if the document.querySelector('.custom-review-stars') have child nodes, then the timer stop
    // otherwise, the timer continue
    let timer;
    function waitForReviewStars() {
      console.log('Waiting for review stars...')
      const reviewShadowRoot = document.querySelector('accordion-element[data-type="review"]')
      if (document.querySelector('.custom-review-stars')?.hasChildNodes() && reviewShadowRoot.textContent.indexOf('START CLEANSLATE')&& reviewShadowRoot.textContent.indexOf('Write a review')) {
        console.log('Review stars have child nodes', document.querySelector('.custom-review-stars').childNodes)
        timer = setTimeout(() => {
          let stop=false
          if (document.querySelector('accordion-element[data-type="review"]')?.hasAttribute('open')) {
            if(document.querySelector('accordion-element[data-type="review"]').offsetHeight<400){
              document.querySelector('accordion-element[data-type="review"] span[slot="heading"]')?.click();
            }else{
              stop=true
            }
          } else {
            document.querySelector('accordion-element[data-type="review"] span[slot="heading"]')?.click();
          }
          console.log('Waiting for review stars... stop ?',stop)
          if (!stop) {
            waitForReviewStars();
          }
        }, 2000);
      } else {
        timer = setTimeout(() => {
          waitForReviewStars();
        }, 300);
      }
    }
    waitForReviewStars();

  }

  function init() {
    // Initial setup
    document.addEventListener('DOMContentLoaded', handleSlotChange);

    // Shopify specific events
    document.addEventListener('shopify:section:load', handleSlotChange);
    document.addEventListener('shopify:block:select', handleSlotChange);

    document.addEventListener('click', (e) => {
      console.log('Click Scroll event:', {
        target: e.target,
        isReivew: e.target.dataset.bvShow,
        timestamp: new Date().toISOString()
      });
      if (e.target.dataset.bvShow || e.target.dataset.bvShow === 'review') {
        // 点击review 或者其他的bvShow 事件
        try {
          const stickyHeader = document.querySelector('.shopify-section-header-sticky');
          if (stickyHeader) {
            stickyHeader.style.opacity = '0';
          }

          // Reset after 30 seconds
          setTimeout(() => {
            const handleScroll = () => {
              const stickyHeader = document.querySelector('.shopify-section-header-sticky');
              if (stickyHeader && stickyHeader.style.opacity === '0') {
                stickyHeader.style.opacity = '1';
                document.removeEventListener('scroll', handleScroll);
              }
            };
            document.addEventListener('scroll', handleScroll);
          }, 5000);
        } catch (error) {
          console.error('Error handling header options:', error);
        }
      }
    });

    // Run immediately if DOM is already loaded
    if (document.readyState === 'complete') {
      handleSlotChange();
    }
  }

  return {
    init: init
  };
})();

// Initialize the module
T4SThemeSP.AccordionTrigger.init();